import { Link } from "react-router-dom";

// Every status and its count, as a row of tiles. The simple answer to "how many
// leads are in each stage". Counts follow the dashboard date range and the two
// global filters.
//
// Each tile links to the Leads page for that status and the same date range, so
// the number and the list agree. The global filters reach the Leads page
// through localStorage.
const DOT_COLORS = {
  new: "bg-teal-400",
  contacted: "bg-sky-500",
  scheduled: "bg-amber-400",
  converted: "bg-emerald-500",
  noshow: "bg-orange-400",
  lost: "bg-rose-400",
};

const StatusStrip = ({ leadStatusData = [], days, dateRangeLabel }) => {
  // Only the statuses a lead can hold. status_counts also returns any stray
  // value found in the table, which would make a tile that links nowhere.
  const rows = leadStatusData.filter((row) => row.key in DOT_COLORS);
  if (rows.length === 0) return null;

  const total = rows.reduce((sum, row) => sum + row.value, 0);

  return (
    <section className="bg-white p-4 rounded-xl shadow-sm" data-attr="status-strip">
      <div className="flex items-baseline justify-between mb-3">
        <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-500">
          Leads by status
        </h3>
        <span className="text-xs text-gray-500">
          {dateRangeLabel} · {total.toLocaleString()} {total === 1 ? "lead" : "leads"}
        </span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2">
        {rows.map((row) => (
          <Link
            key={row.key}
            to={`/leads?status=${row.key}&days=${days}`}
            data-attr={`status-strip-${row.key}`}
            className="rounded-lg border border-border px-3 py-2 hover:bg-teal-50 transition-colors"
          >
            <span className="block text-2xl font-bold text-teal-800">
              {row.value.toLocaleString()}
            </span>
            <span className="flex items-center gap-1.5 text-xs text-gray-600">
              <span
                className={`h-2 w-2 rounded-full ${DOT_COLORS[row.key]}`}
              />
              {row.label}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default StatusStrip;
